export enum BillCreationType {
    AUTO = "AUTO",
    PUSH = "PUSH",
    PULL = "PULL",
}